// set var css
(function () {
    function readHeights() {
        const h = {};
        h.windowHeight = window.innerHeight;
        h.announcementHeight = getHeight("#shopify-section-announcement-bar");
        h.headerHeight = getHeight("#shopify-section-header sticky-header");
        return h;
    }

    function setVarsOnResize() {
        setVars();
        window.addEventListener("resize", setVars);
        window.addEventListener("scroll", setVars);
    }

    function setVars() {
        const { windowHeight, announcementHeight, headerHeight } = readHeights();
        document.documentElement.style.setProperty("--full-height", `${windowHeight}px`);
        document.documentElement.style.setProperty("--announcement-height", `${announcementHeight}px`);
        document.documentElement.style.setProperty("--height-fixed-header", `${headerHeight}px`);
        document.documentElement.style.setProperty("--content-full", `${windowHeight - headerHeight}px`);
    }

    function getHeight(selector) {
        const el = document.querySelector(selector);
        return el ? el.clientHeight : 0;
    }

    document.addEventListener("DOMContentLoaded", function () {
        setVarsOnResize();
    });
})();

document.addEventListener("DOMContentLoaded", function () {
    // Announcement bar js
    if (document.querySelector(".announcement__text")) {
        let aTextWidth = document.querySelector(".announcement__text").clientWidth;
        let firstClientWidth = window.innerWidth;
        let mediaQueryA = window.matchMedia(`(max-width: ${aTextWidth + 40}px)`);
        let aTextEls = document.querySelector(".announcement__text");
        let aBar = document.querySelector(".announcement-bar");
        let aTextClone = aTextEls.innerHTML;
        let aCloser = document.querySelector(".announcement__close");

        if (sessionStorage.getItem("aBarClose") == "true") {
            aBar.classList.add("hidden");
        } else aBar.classList.remove("hidden");

        aCloser &&
            aCloser.addEventListener("click", function () {
                sessionStorage.setItem("aBarClose", "true");
                aBar.classList.add("hidden");
            });

        if (firstClientWidth < aTextWidth + 40) {
            aTextEls.innerHTML += aTextClone;
            aTextEls.style.width = `${(aTextWidth + 30) * 2}px`;
            aBar.classList.add("marquee");
        } else {
            aTextEls.innerHTML = aTextClone;
            aTextEls.style.width = "auto";
            aBar.classList.remove("marquee");
        }

        function screenTest(e) {
            if (e.matches) {
                aTextEls.innerHTML += aTextClone;
                aTextEls.style.width = `${(aTextWidth + 30) * 2}px`;
                aBar.classList.add("marquee");
            } else {
                aTextEls.innerHTML = aTextClone;
                aTextEls.style.width = "auto";
                aBar.classList.remove("marquee");
            }
        }

        mediaQueryA.addEventListener("change", screenTest);
    }
    // Change site popup footer
    if (document.querySelector(".site-changer")) {
        let siteChangerPopup = document.querySelector(".footer__site-change-wrapper");
        let siteChanger = document.querySelector(".site-changer");
        let siteLink = siteChanger.getAttribute("href");
        let popupSubmit = siteChangerPopup.querySelector(".popup-submit");

        siteChanger.addEventListener("click", showPopup);

        siteChangerPopup
            .querySelectorAll(".popup-close-js")
            .forEach((item) => item.addEventListener("click", (e) => siteChangerPopup.classList.remove("active")));

        // if (!sessionStorage.getItem("country") && document.body.getAttribute("theme-location") == "AU") {
        //     setTimeout(() => {
        //         fetch("https://ipwhois.pro/?key=oCEDS0jrbeijRRbB")
        //             .then((r) => r.json())
        //             .then((response) => {
        //                 console.log(response);
        //                 if (response.country_code === "US") {
        //                 // if (response.country_code !== "AU" && response.country_code !== "NZ") {
        //                     siteChanger.click();
        //                     sessionStorage.setItem("country", response.country_code);
        //                 }
        //             })
        //             .catch((error) => {
        //                 console.error(error);
        //             });
        //     }, 3000);
        // }
        function showPopup(e) {
            e.preventDefault();
            siteChangerPopup.classList.add("active");
            if (!popupSubmit.hasAttribute("href")) popupSubmit.setAttribute("href", siteLink);
        }
    }


    // Redirect Popup
    const redirectPopup = document.querySelector('.redirect-popup');

    if (redirectPopup !== null) {

      const closePopup = () => {
        sessionStorage.setItem('disabledPopup', true);
        redirectPopup.classList.remove('popup--is-visible');
        const closeTimeout = setTimeout(() => {
          redirectPopup.classList.remove('popup--active');
          clearTimeout(closeTimeout);
        }, 300);
      };

      fetch('https://ipwhois.pro/?key=oCEDS0jrbeijRRbB')
        .then((response) => response.json())
        .then((data) => {
          if (document.body.getAttribute('theme-location') === 'AU') {
            if (data.country_code === 'AU' || data.country_code === 'NZ') {
              closePopup();
            } 
          } else {
            if (data.country_code !== 'AU' && data.country_code !== 'NZ') {
              closePopup();
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });

      if (sessionStorage.getItem('disabledPopup')) return;

      redirectPopup.classList.add('popup--active');
      redirectPopup.offsetHeight;
      const openTimeout = setTimeout(() => {
        redirectPopup.classList.add('popup--is-visible');
        clearTimeout(openTimeout);
      }, 1000);
      
      
      const popupClose = redirectPopup.querySelectorAll('.popup__close');
      const popupOverlay = redirectPopup.querySelector('.popup__overlay');
      
      popupOverlay.addEventListener('click', (event) => {
        event.preventDefault();
        closePopup();
      })

      popupClose.forEach((close) => {
        close.addEventListener('click', (event) => {
          event.preventDefault();
          closePopup();
        });
      });
      
    }
});
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == "string") {
        cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
        return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ",");
        decimal = defaultOption(decimal, ".");

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split("."),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
            cents = parts[1] ? decimal + parts[1] : "";

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

document.addEventListener("DOMContentLoaded", function () {
    let elm = document.querySelector("#mst-iwish-drawer-root");

    const observer1 = new MutationObserver(checkElm);
    function checkClass(mul, ob) {
        mul.forEach((mu) => {
            if (mu.type === "attributes" && mu.attributeName === "class") {
                if (mu.target.classList.contains("open")) {
                    document.body.classList.add("overflow-hidden-mobile", "overflow-hidden-tablet", "overflow-hidden");
                    disablePageScroll(mu.target);
                } else {
                    document.body.classList.remove("overflow-hidden-mobile", "overflow-hidden-tablet", "overflow-hidden");
                    enablePageScroll();
                }
            }
        });
    }
    function checkElm(mutationList, observer) {
        let wishlistDrawer = false;
        mutationList.forEach(function (mutation) {
            if (wishlistDrawer) {
                observer1.disconnect();
                return false;
            }

            const btn = document.querySelector(".react-side-draw");
            if (btn) {
                const observer2 = new MutationObserver(checkClass);
                observer2.observe(btn, {
                    attributes: true,
                });
                wishlistDrawer = true;
            }
        });
    }
    if (elm) {
        observer1.observe(elm, {
            childList: true,
        });
    }
});
